import MockLoadingBlock from "../../../mock/MockLoadingBlock";
import layoutClasses from "../WorkQComponent.module.css";
import classes from "./PoliceReportWorkQLoading.module.css";

const LIST_PLACEHOLDER_COUNT = 6;

export function PoliceReportListSkeleton() {
    return (
        <div className={layoutClasses.police_report_list}>
            {Array.from({ length: LIST_PLACEHOLDER_COUNT }, (_, i) => (
                <div key={i} className={classes.list_row}>
                    <MockLoadingBlock height={48} noMargin />
                </div>
            ))}
        </div>
    );
}

/** Skeleton for custom police-report layout (list + optional details), not the standard table MockWorkQ. */
export default function PoliceReportWorkQLoading({ showDetails = false }) {
    return (
        <div className={layoutClasses.police_report_main}>
            <PoliceReportListSkeleton />
            {showDetails && (
                <div className={classes.details_panel}>
                    <MockLoadingBlock height={700} width="100%" noMargin />
                </div>
            )}
        </div>
    );
}
